import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'deviceStatus',
    standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class DeviceStatusPipe implements PipeTransform {

  transform(value: any, filterName: any) {
    switch (filterName) {
      case 'statusNameAction':
        return this.translateStatusNameAction(value);
      case 'statusNamePassive':
        return this.translateStatusNamePassive(value);
      case 'likelyLeaveReason':
        return this.translateLikelyLeaveReason(value);
      case 'batteryHealth':
        return this.translateBatteryHealth(value);
      case 'batterySource':
        return this.translateBatterySource(value);
      case 'batteryStatus':
        return this.translateBatteryStatus(value);
      case 'displayDensity':
        return this.translateDisplayDensity(value);
      case 'networkType':
        return this.translateNetworkType(value);
      case 'networkSubType':
        return this.translateNetworkSubType(value);
      case 'humanizedBool':
        return this.translateHumanizedBool(value);
      default:
        return '-';
    }
  }

  private translateStatusNameAction(text: any) {
    const translations = {
      absent: 'Disconnected',
      present: 'Connected',
      offline: 'Offline',
      unauthorized: 'Unauthorized',
      preparing: 'Preparing',
      ready: 'Ready',
      using: 'Stop Using',
      busy: 'Busy',
      available: 'Use',
      automation: 'Stop Automation'
    };
    return translations[text] || 'Unknown';
  }

  private translateStatusNamePassive(text: any) {
    const translations = {
      absent: 'Disconnected',
      present: 'Connected',
      offline: 'Offline',
      unauthorized: 'Unauthorized',
      preparing: 'Preparing',
      ready: 'Ready',
      using: 'Using',
      busy: 'Busy',
      available: 'Available',
      automation: 'Automating'
    };
    return translations[text] || 'Unknown';
  }

  private translateLikelyLeaveReason(text: any) {
    
    const translations = {
      ungroup_request: 'You (or someone else) kicked the device.',
      owner_change: 'Someone stole your device.',
      automatic_timeout: 'Device was kicked by automatic timeout.',
      device_absent: 'Device is not present anymore for some reason.',
      status_change: 'Device is present but offline.'
    };
    return translations[text] || 'Device not reachable.';
  }

  private translateBatteryHealth(text: any) {
    const translations = {
      cold: 'Cold',
      good: 'Good',
      dead: 'Dead',
      over_voltage: 'Over Voltage',
      overheat: 'Overheat',
      unspecified_failure: 'Unspecified Failure'
    };
    return translations[text] || '-';
  }

  private translateBatterySource(text: any) {
    const translations = {
      ac: 'AC',
      usb: 'USB',
      wireless: 'Wireless'
    };
    return translations[text] || '-';
  }

  private translateBatteryStatus(text: any) {
    const translations = {
      charging: 'Charging',
      discharging: 'Discharging',
      full: 'Full',
      not_charging: 'Not Charging'
    };
    return translations[text] || '-';
  }

  private translateDisplayDensity(text: any) {
    const translations = {
      '0.5': 'LDPI', // (120 dpi)
      '1': 'MDPI', // (160 dpi)
      '1.5': 'HDPI', // (240 dpi)
      '2': 'XHDPI', // (320 dpi)
      '3': 'XXHDPI', // (480 dpi)
      '4': 'XXXHDPI' // (640 dpi)
    };
    return translations[text] || text;
  }

  private translateNetworkType(text: any) {
    const translations = {
      bluetooth: 'Bluetooth',
      dummy: 'Dummy',
      ethernet: 'Ethernet',
      mobile: 'Mobile',
      mobile_dun: 'Mobile DUN',
      mobile_hipri: 'Mobile High Priority',
      mobile_mms: 'Mobile MMS',
      mobile_supl: 'Mobile SUPL',
      mobile_wifi: 'WiFi',
      wimax: 'WiMAX'
    };
    return translations[text] || text;
  }

  private translateNetworkSubType(text: any) {
    const translations = {
      mobile_wifi: 'WiFi'
    };
    return translations[text] || text;
  }

  private translateHumanizedBool(text: any) {
    switch (text) {
      case true:
        return 'Yes';
      case false:
        return 'No';
      default:
        return '-';
    }
  }
}
